/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { Exposure } from 'shihuo-lib/dist/shihuo-lib';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

class PipelineSearchCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.exp = new Exposure(); // 曝光
    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = document.body.clientWidth / 375;
    }
  }

  componentDidMount() {}

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);

  }

  handleViewAll = () => {
    const viewAllLink = this.props.config.baseConfig.viewAllLink;
    if (!viewAllLink) {
      return;
    }
    const options = {
      link: viewAllLink,
    };

    const convertUrl = utils.convertHref(viewAllLink);
    utils.jumpToUrl(this.props.routeParams,convertUrl,viewAllLink, options, -1,this.props,false, {
      id: 'legoSearchCard:watch_more',
      name: 'pipeline-searchCard',
      from: 'lego_search_card',
      block: 'watch_more',
      tpName: this.props.searchWords,
    });
  }

  renderCard = ({ item, index, scroll, isLast }) => {
    const imgSize = scroll ? px2rem('90px', false) : px2rem('103px', false);
    return (
      <div className="card-item"
        onClick={this.handleItemClick.bind(this, item, index)}
        data-dot={JSON.stringify({
          id: 'legoSearchCard:card',
          name: 'pipeline-searchCard',
          href: '',//跳转的 href, 非必传
          exposekey: 'card',//必传
          pti_refer: {
            // pageId: this.pageId,
            root: {
              // pageId: this.pageId,
              biz: ''
            },
            parent: {},
          },
        })}              
        ref={ele => {
          if (ele) {
            this.exp.add({ el: ele });
          }
        }} 
        style={{
          marginRight:isLast ? 0 : px2rem('8px', false),
        }}
      >
        <div className="img-container" style={{ width: imgSize, height: imgSize }}>
          <img className="img" src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
        </div>
        <React.Fragment>
          <div className="name" style={{ width: imgSize, height: px2rem('17px', false), marginTop: px2rem('4px', false), marginBottom: px2rem('0px', false), fontSize: px2rem('12px', false), lineHeight: px2rem('17px', false) }}>{item.name}</div>
          <div className="price" style={{ height: px2rem('18px', false) }}>
            {item.price && (
              <div className="rmb-icon" style={{ fontSize: px2rem('11px', false) }}>¥</div>
            )}
            <div className="rmb-num" style={{ fontSize: px2rem('16px', false) }}>{item.price}</div>
          </div>
        </React.Fragment>
      </div>
    )
  }

  render() {
    const { baseConfig, imgsList } = this.props.config;
    let cardList = [...imgsList];
    const scroll = Boolean(cardList.length > 3);

    const Card = this.renderCard;
    const cardListElement = cardList.map((item, index) => <Card item={item} scroll={scroll} index={index} isLast={index === (cardList.length - 1)} />);
    return (
      <div
        className="pipeline-search-card"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          marginBottom: px2rem('10px', false),
        }}
      >
        {scroll ?
          (
            <div className="card-list scroll-card-list">
              <div style={{ paddingLeft: px2rem('12px', false), height: 10 }}></div>
              {cardListElement}
              <div
                className="all-btn"
                onClick={this.handleViewAll}
                style={{ height: px2rem('90px', false), marginLeft: px2rem('8px', false) }}
                data-dot={JSON.stringify({
                  id: 'legoSearchCard:watch_more',
                  name: 'pipeline-searchCard',
                  href: '',//跳转的 href, 非必传
                  exposekey: 'watch_more',//必传
                  pti_refer: {
                    // pageId: this.pageId,
                    root: {
                      // pageId: this.pageId,
                      biz: ''
                    },
                    parent: {},
                  },
                })}              
                ref={ele => {
                  if (ele) {
                    this.exp.add({ el: ele });
                  }
                }}   
              >
                <img className="all-img" src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20211014/ffc32c3ae5754a3b5983eb245f2cd4da.png', this.props.webpSupport)} alt="all" style={{ width: px2rem('30px', false), marginLeft: px2rem('17px', false), marginRight: px2rem('17px', false), marginTop: px2rem('28px', false), marginBottom: px2rem('6px', false) }} />
                <div style={{ fontSize: px2rem('11px', false), color: '#333', textAlign: 'center' }}>查看全部</div>
              </div>
              <div style={{ paddingLeft: px2rem('12px', false), height: 10 }}></div>
            </div>
          ) :
          (
            <div className="card-list" style={{ marginLeft: px2rem('12px', false), marginRight: px2rem('12px', false) }}>
              {cardListElement}
            </div>
          )
        }
      </div>
    );
  }
}

PipelineSearchCard.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSearchCard };
export default PipelineSearchCard;



// WEBPACK FOOTER //
// ./components/pipeline-searchCard/index.js